import type { RouteObject } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import { cloneDeep } from 'lodash';

import { LoginRoutes, AppMainRoutes, AppRoutes } from '@/router';
import { useAuthenticate } from '@/context/AuthenticateContext';

import 'perfect-scrollbar/css/perfect-scrollbar.css';

export const App = () => {
  const { isLoggedIn } = useAuthenticate();
  const routes = [...LoginRoutes];
  if (isLoggedIn) {
    const authRouters: RouteObject = cloneDeep(AppMainRoutes);
    const temp: RouteObject[] = [...AppRoutes];
    if (!!temp.length) temp.forEach((item) => authRouters.children!.push(item));
    routes.push(authRouters);
  }
  const elements = useRoutes(routes);
  return elements;
};

export function findRoute(routeList: RouteObject[], path: string): RouteObject {
  return routeList.find((c) => c.path === path)!;
}
